export default "__VITE_ASSET__Bb3UAMi3__"